import { Input, Tabs, Card, Spin } from "antd";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Fuse from "fuse.js";

const SearchWithTabs = () => {
  const [query, setQuery] = useState("");
  const [activeTab, setActiveTab] = useState("ideas");
  const [isFocused, setIsFocused] = useState(false);
  const [symbolData, setSymbolData] = useState([]);
  const [sectorData, setSectorData] = useState([]);
  const [sectorBlogs, setSectorBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const containerRef = useRef();
  const navigate = useNavigate();

  const mockData = {
    ideas: [
      "Top 3 Undervalued Growth Stocks for 2025",
      "AI Stocks Poised for Long-Term Upside",
      "Dividend Kings to Buy Before Rate Cuts",
    ],
    symbols: [],
    sectors: [],
    analysis: [
      "Apple: Is the Services Segment Driving Growth?",
      "Tesla: Software Margins or Manufacturing Edge?",
      "Nvidia: Too Expensive or Justified?",
    ],
    screens: [
      "High ROIC Stocks under $10B Market Cap",
      "Low Debt + Consistent Free Cash Flow",
      "New 52-Week Highs with Insider Buying",
    ],
    "earning-call-summary": [
      "Nvidia Q1 FY25: 262% YoY Growth in Data Center Revenue",
      "Amazon Q4 2024: AWS Recovery & Margin Expansion",
      "Palantir Q1 2025: Gov Cloud Contracts + Profitability",
    ],
    "stocks-wiki": [
      "What does ROIC mean?",
      "What is a PEG Ratio?",
      "Why Insider Trading is a Key Signal",
    ],
  };

  useEffect(() => {
    Promise.all([
      fetch(process.env.PUBLIC_URL + "/symbols.json").then((res) => res.json()),
      fetch(process.env.PUBLIC_URL + "/sector.json").then((res) => res.json()),
      fetch(process.env.PUBLIC_URL + "/sector_blogs.json").then((res) =>
        res.json()
      ),
    ])
      .then(([symbols, sectors, blogs]) => {
        setSymbolData(symbols);
        setSectorData(sectors);
        setSectorBlogs(blogs);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSearch = (value) => {
    setQuery(value);
  };

  // const filteredResults = () => {
  //   if (!query) {
  //     if (activeTab === "symbols") return symbolData;
  //     if (activeTab === "sectors") return sectorData;
  //     return mockData[activeTab] || [];
  //   }

  //   if (activeTab === "symbols") {
  //     const fuse = new Fuse(symbolData, {
  //       keys: ["symbol", "name"],
  //       threshold: 0.4,
  //     });
  //     return fuse.search(query).map((r) => r.item);
  //   }

  //   if (activeTab === "sectors") {
  //     const fuse = new Fuse(sectorData, { keys: ["name"], threshold: 0.4 });
  //     return fuse.search(query).map((r) => r.item);
  //   }

  //   return mockData[activeTab]?.filter((item) =>
  //     item.toLowerCase().includes(query.toLowerCase())
  //   );
  // };

  const filteredResults = () => {
    if (!query) {
      if (activeTab === "symbols")
        return symbolData.length > 0 ? symbolData : null;
      if (activeTab === "sectors")
        return sectorData.length > 0 ? sectorData : null;
      return mockData[activeTab] || [];
    }

    if (activeTab === "symbols") {
      const fuse = new Fuse(symbolData, {
        keys: ["symbol", "name"],
        threshold: 0.4,
      });
      return fuse.search(query).map((r) => r.item);
    }

    if (activeTab === "sectors") {
      const fuse = new Fuse(sectorData, { keys: ["name"], threshold: 0.4 });
      return fuse.search(query).map((r) => r.item);
    }

    return mockData[activeTab]?.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    );
  };

  const relatedBlogs = (sectorSlug) => {
    return sectorBlogs.filter((blog) => blog.sector === sectorSlug);
  };

  const handleClickOutside = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setIsFocused(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        width: "60vw",
        maxWidth: "80vw",
        margin: "auto",
        marginTop: "15vh",
        boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Input.Search
        value={query}
        placeholder="Search ideas, stocks, screens..."
        enterButton
        size="large"
        onSearch={handleSearch}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => setIsFocused(true)}
        style={{ marginBottom: 20 }}
      />

      {loading ? (
        <Spin tip="Loading data..." style={{ width: "100%", marginTop: 50 }} />
      ) : (
        isFocused && (
          <>
            <Tabs
              activeKey={activeTab}
              // onChange={(key) => setActiveTab(key)}
              onChange={(key) => {
                setActiveTab(key);
                setQuery("");
              }}
              centered
              items={[
                { label: "Ideas", key: "ideas" },
                { label: "Symbols", key: "symbols" },
                { label: "Sectors", key: "sectors" },
                { label: "Company-Analysis", key: "analysis" },
                { label: "Screens", key: "screens" },
                { label: "Earning-call-Summary", key: "earning-call-summary" },
                { label: "Stocks-Wiki", key: "stocks-wiki" },
              ]}
            />

            <div style={{ marginTop: 20 }}>
              {/* {filteredResults().length > 0 ? ( */}
              {filteredResults() && filteredResults().length > 0 ? (
                filteredResults().map((item, index) => {
                  if (activeTab === "symbols") {
                    return (
                      <Card
                        key={item.symbol}
                        style={{ marginBottom: 12, backgroundColor: "#fafafa" }}
                        hoverable
                        onClick={() => navigate(`/${item.symbol}`)}
                      >
                        {item.symbol} - {item.name}
                      </Card>
                    );
                  } else if (activeTab === "sectors") {
                    return (
                      <div key={item.sector}>
                        <Card
                          style={{
                            marginBottom: 12,
                            backgroundColor: "#fafafa",
                          }}
                          hoverable
                          onClick={() => navigate(`/sector/${item.sector}`)}
                        >
                          {item.name}
                        </Card>
                        <div style={{ paddingLeft: 20, paddingTop: 8 }}>
                          {relatedBlogs(item.sector).map((blog, idx) => (
                            <p
                              key={idx}
                              style={{
                                marginBottom: 8,
                                cursor: "pointer",
                                color: "#174ea6",
                              }}
                              onClick={() =>
                                navigate(`/blogs/sector/${blog.slug}`)
                              }
                            >
                              • {blog.title}
                            </p>
                          ))}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <Card
                        key={index}
                        style={{ marginBottom: 12, backgroundColor: "#fafafa" }}
                        hoverable
                        onClick={() => {
                          if (activeTab === "ideas") {
                            setQuery(item); // Trigger search
                            setIsFocused(true);
                          }
                        }}
                      >
                        {item}
                      </Card>
                    );
                  }
                })
              ) : (
                <p>No matching results for "{query}"</p>
              )}
            </div>
          </>
        )
      )}
    </div>
  );
};

export default SearchWithTabs;
